/* eslint-disable import/prefer-default-export */
export const GetConsoleWebConfig = `query getConsoleWebConfig($clientId: String!, $configurationVersion: Int) {
  getConsoleWebConfig(clientId: $clientId, configurationVersion: $configurationVersion) {
    headers
    body
  }
}
`
